<script>
    import { mapActions } from "vuex";
    import { sendAnalytics } from "@/core/SendAnalytics";
    import { myTarget } from "@/core/SendMyTarget";
    import BaseButton from "@main/packages/BaseButton";

    export default {
        name: "ProductCardButtons",
        components: { BaseButton },
        props: {
            isPreOrder: Boolean,
            inCart: Boolean,
            offerId: Number,
            product: Object,
            discountPrice: Number,
            sizeButton: {
                default: "md",
                type: String,
            },
            initialText: {
                type: String,
                default: "Купить",
            },
            preorderTextMobile: {
                type: String,
                default: "Узнать о поступлении",
            },
            isTechEvent: Boolean,
            variantBuyButton: {
                default: "v1",
                type: String,
            },
            variantPreorderButton: {
                type: String,
                default: "v3",
            },
        },
        data() {
            return {
                isLoadingBuyButton: false,
                currentInCart: this.inCart,
            };
        },
        computed: {
            textForButton() {
                return this.currentInCart ? "В корзине" : this.initialText;
            },
        },
        watch: {
            inCart: {
                handler(updatedInCart) {
                    this.currentInCart = updatedInCart;
                },
            },
        },
        methods: {
            ...mapActions("Root", ["addProductInCart"]),
            add(e) {
                if (this.isTechEvent) {
                    // Ledger
                    e.stopPropagation();
                    e.preventDefault();
                }
                if (this.currentInCart) {
                    return this.$router.push({ name: "Order" });
                }

                this.isLoadingBuyButton = true;

                this.addProductInCart({
                    quantity: 1,
                    productId: this.offerId,
                }).then(() => {
                    this.isLoadingBuyButton = false;
                    this.currentInCart = true;

                    this.$emit("on-added-to-cart");

                    sendAnalytics.send(sendAnalytics.events.addToCart, {
                        name: this.product.name,
                        offerId: this.offerId,
                        price: this.discountPrice,
                    });

                    myTarget.cart(myTarget.pageTypes.addToCart, {
                        name: this.product.name,
                        offerId: this.offerId,
                        price: this.discountPrice,
                    });
                });
            },
            showPreOrder(e) {
                if (this.isTechEvent) {
                    // Ledger
                    e.stopPropagation();
                    e.preventDefault();
                }
                this.$popup.show("modal-pre-order", { offerId: this.offerId });
            },
        },
    };
</script>

<template>
    <div class="product-card__controls">
        <base-button
            class="product-card__control-button"
            v-if="!isPreOrder"
            :variant="variantBuyButton"
            :size="sizeButton"
            :is-loading="isLoadingBuyButton"
            :is-selected="currentInCart"
            @click="add"
        >
            <span>
                {{ textForButton }}
            </span>
            <slot name="iconBuy"></slot>
            <preloader slot="preloader" :show="isLoadingBuyButton" sm-size></preloader>
        </base-button>

        <base-button
            class="product-card__control-button product-card__control-button--preorder"
            v-if="isPreOrder"
            :variant="variantPreorderButton"
            :size="sizeButton"
            @click="showPreOrder"
        >
            <span class="mobile-hidden">Узнать о поступлении</span>
            <span class="desktop-hidden">{{ preorderTextMobile }}</span>
            <slot name="iconPreorder"></slot>
        </base-button>
    </div>
</template>

<style lang="scss">
    .product-card__controls {
        display: flex;
    }

    .product-card__control-button {
        width: 100%;
    }

    .product-card__control-button--preorder {
        &.base-button {
            font-size: var(--btn-size-pre-order);
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }
</style>
